// 门诊慢特病病种申请——微信，主流程
const wxMainRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `apply/wx/index${i + 1}`,
  name: `applyWxIndex${i + 1}`,
  component: () => import(`@/views/health/apply/wx/index${i + 1}.vue`)
}))

// 门诊慢特病病种申请——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `apply/zfb/index${i + 1}`,
  name: `applyZfbIndex${i + 1}`,
  component: () => import(`@/views/health/apply/zfb/index${i + 1}.vue`)
}))

export default {
  path: '/health',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 门诊慢特病病种申请——微信，开始
    ...wxMainRoutes,

    // 门诊慢特病病种申请——支付宝，主流程
    ...zfbMainRoutes
  ]
}
